import { useAppSelector } from '../../hooks/useAppSelector';
import { styled } from '@mui/material/styles';
import { Toolbar, Link, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as uiSlice from '../../data/ui.slice';

const PREFIX = 'EulaDialog';

const classes = {
  footer: `${PREFIX}-appbar`,
  toolbar: `${PREFIX}-toolbar`,
  toolbarQuestion: `${PREFIX}-toolbar-question`,
  logo: `${PREFIX}-logo`,
  link: `${PREFIX}-link`,
};

const StyledAppBar = styled('footer')(({ theme }) => ({
  [`&.${classes.footer}`]: {
    backgroundColor: '#011012',
    color: '#fff',
    bottom: 0,
    top: 'auto',
  },

  [`& .${classes.toolbar}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'Source Sans Pro',
    padding: theme.spacing(3),
    alignItems: 'center',
    height: '161px',
  },

  [`& .${classes.toolbarQuestion}`]: {
    gap: theme.spacing(6),
    display: 'flex',
    paddingRight: 3,
    alignItems: 'center',
  },

  [`& .${classes.logo}`]: {
    width: 184,
  },

  [`& .${classes.link}`]: {
    cursor: 'pointer',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
}));

export default function HomeFooterBar() {
  const { t } = useTranslation('common');
  const { __environment__ } = window as any;
  const faqUrl = __environment__.REACT_APP_FAQ_LINK.trim();
  const serviceDeskUrl = __environment__.REACT_APP_SERVICE_DESK_LINK.trim();
  const faqContext = useAppSelector(uiSlice.selectFAQContext);

  const gotoFaq = (evt: any) => {
    evt.preventDefault();
    const url = `${faqUrl}#${faqContext}`;
    window.open(url, '_blank');
  };

  const gotoServiceURL = (evt: any) => {
    evt.preventDefault();
    const url = `${serviceDeskUrl}`;
    window.open(url, '_blank');
  };
  return (
    <StyledAppBar className={classes.footer}>
      <Box className={classes.toolbar}>
        <img src="/logo2.png" alt="logo" className={classes.logo} />
        <Box className={classes.toolbarQuestion}>
          {t('footer.questions')}
          <Link
            className={classes.link}
            href="#"
            color="inherit"
            underline="hover"
            onClick={gotoFaq}>
            {t('footer.privacyPolicy')}
          </Link>
          <Link
            className={classes.link}
            onClick={gotoServiceURL}
            color="inherit"
            underline="hover">
            {t('footer.termsAndConditions')}
          </Link>
        </Box>
      </Box>
    </StyledAppBar>
  );
}
